<template>
  <!-- COMPONENTE ONDE SURGE OS PRODUTOS DE CADA ENCOMENDA -->
  <div class="card">
    <span id="loading" v-if="this.loading == true">
      <Loading />
    </span>
    <h3>Encomenda nº {{ orderId }}</h3>
    <!-- FORMULÁRIO PARA FAZER O REGISTO DE UM PRODUTO -->
    <div class="row">
      <div class="col registerInput">
        <form v-on:submit.prevent="registeProduct()" class="form-container">
          <div class="form-group row align-items-center">
            <label
              for="ean"
              id="eanLabel"
              class="col-sm-2 col-form-label text-right font-weight-bold"
              >EAN:</label
            >
            <div class="col-sm-6 input-group">
              <input
                type="text"
                class="form-control form-control-sm rounded"
                id="ean"
                autofocus
                v-model="ean"
                :placeholder="
                  pasteAllowed
                    ? 'Insira ou cole o EAN'
                    : 'Use o leitor de código de barras'
                "
                @input="handleInput"
                @paste="handlePaste($event)"
                ref="eanInput"
              />
              <!-- Ícone para desbloquear colagem -->
              <div class="input-group-append" v-if="!pasteAllowed">
                <span
                  class="input-group-text unlock-icon"
                  title="Desbloquear colagem"
                  @click="openAcceptModal"
                >
                  <i class="fas fa-unlock-alt"></i>
                </span>
              </div>
            </div>
            <div class="col-sm-2 text-center">
              <button type="submit" class="btn btn-primary btn-sm rounded">
                Registar
              </button>
            </div>
          </div>
          <div
            v-if="this.lastRegist"
            class="last-registered text-muted text-center mt-2"
          >
            Último registo: <i>{{ lastRegist }}</i>
          </div>
        </form>

        <!-- Modal para aceitar os riscos -->
        <b-modal ref="acceptModal" title="Desbloquear Colagem" hide-footer>
          <div class="modal-body">
            <p class="text-justify">
              Recomendamos a leitura do código de barras (picagem), que é mais
              segura e eficiente. Caso opte por colar, confirme que entende os
              riscos escrevendo <strong>"S"</strong> no campo abaixo e pressione
              Enter.
            </p>
            <input
              type="text"
              class="form-control"
              v-model="acceptInput"
              placeholder="Digite 'S'"
              @keyup="handleAcceptKeyPress"
            />
          </div>
          <div class="modal-footer text-right">
            <button
              class="btn btn-success btn-sm rounded"
              :disabled="acceptInput.trim().toLowerCase() !== 's'"
              @click="allowPaste"
            >
              Confirmar
            </button>
          </div>
        </b-modal>
      </div>

      <div class="col">
        <div class="row">
          <div class="col">
            <div class="box box1">
              <img :src="img" />
            </div>
          </div>
          <div class="col infoProduct">
            <div class="form-group">
              <div class="input-group mb-2 mr-sm-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">SKU</div>
                </div>
                <input
                  type="text"
                  class="form-control form-control"
                  id="sku"
                  v-model="skuInfo"
                  disabled
                />
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2 mr-sm-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">EAN</div>
                </div>
                <input
                  type="text"
                  class="form-control form-control"
                  id="ean"
                  v-model="eanInfo"
                  disabled
                />
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2 mr-sm-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Name</div>
                </div>
                <input
                  type="text"
                  class="form-control form-control"
                  id="productName"
                  disabled
                  v-model="nameInfo"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <!-- 2 COLUNAS -->
    <b-container>
      <b-row align-v="center">
        <!-- PRIMEIRA COLUNA: DATA -->
        <b-col cols="2" class="text-center">
          <p class="mb-0 fw-bold text-secondary" style="font-size: 0.95rem">
            {{ this.order[0].date }}
          </p>
        </b-col>

        <!-- SEGUNDA COLUNA: PRODUTOS -->
        <b-col cols="8" class="d-flex flex-column align-items-start">
          <div
            v-for="article in articles"
            :key="`${article.id_request}-${article.sku}`"
            class="mb-2 w-100"
            :style="
              () => {
                const match = produtsRegisted.find(
                  (item) =>
                    item.sku === article.sku &&
                    (!item.id_request ||
                      !article.id_request ||
                      String(item.id_request) === String(article.id_request))
                );
                return {
                  borderBottom: '1px solid #ddd',
                  paddingBottom: '6px',
                  backgroundColor:
                    match && match.registed === article.quantity
                      ? '#e6f9e6'
                      : 'transparent',
                };
              }
            "
          >
            <div
              class="d-flex justify-content-between align-items-center w-100"
              style="gap: 1rem"
            >
              <!-- Info do produto -->
              <p class="mb-0 d-flex align-items-center flex-wrap">
                <span class="me-1 fw-bold">{{ article.quantity }}x</span>
                <span class="me-2 text-monospace" style="font-size: 0.95rem">
                  {{ article.sku }}
                </span>
                -
                <a
                  id="openArticle"
                  v-b-modal.modal-4
                  class="ms-2 text-decoration-underline text-primary"
                  @click="passProductData(article)"
                  style="cursor: pointer; font-weight: 500"
                >
                  {{ article.name }}
                </a>
                <span
                  class="ms-2"
                  style="color: red; font-size: 0.9rem"
                  v-if="
                    article.notes &&
                    article.notes !== 'null' &&
                    article.notes.trim() !== ''
                  "
                >
                  – <b>{{ article.notes }}</b>
                </span>
              </p>

              <!-- Contador -->
              <p
                class="mb-0 text-end"
                :style="
                  () => {
                    const match = produtsRegisted.find(
                      (item) =>
                        item.sku === article.sku &&
                        (!item.id_request ||
                          !article.id_request ||
                          String(item.id_request) ===
                            String(article.id_request))
                    );
                    return {
                      color:
                        match && match.registed === article.quantity
                          ? 'green'
                          : '#6c757d',
                      fontWeight: '500',
                      minWidth: '45px',
                    };
                  }
                "
              >
                {{
                  produtsRegisted.find(
                    (item) =>
                      item.sku === article.sku &&
                      (!item.id_request ||
                        !article.id_request ||
                        String(item.id_request) === String(article.id_request))
                  )?.registed || 0
                }}/{{ article.quantity }}
              </p>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <hr />
    <b-row>
      <b-col cols="10"></b-col>
      <b-col cols="2">
        <span v-if="this.arrayArticles.length == 0 || this.arrayArticles == ''">
          <button
            id="next"
            type="submit"
            class="btn btn-primary mb-2"
            @click="choiceCompany()"
            cols="2"
          >
            Seguinte
          </button></span
        >
        <span v-else
          ><button type="submit" class="btn btn-primary mb-2" cols="2" disabled>
            Seguinte
          </button></span
        ></b-col
      ></b-row
    >
    <!-- MODAL PARA MOSTRAR O PRODUTO -->
    <b-modal
      ref="modal_product"
      id="modal-4"
      title="Produto"
      size="lg"
      hide-footer
    >
      <div class="card">
        <b-container>
          <b-row align-v="center"
            ><b-col class="left">
              <!-- IMAGEM DO PRODUTO -->
              <img :src="imgProduct" />
            </b-col>
            <b-col>
              <p><span id="subtitle">STOCK: </span> {{ stockProduct }}</p>
              <p><span id="subtitle">EAN:</span> {{ eanProduct }}</p>
              <p><span id="subtitle">SKU:</span> {{ skuProduct }}</p>
              <p><span id="subtitle">HS Code:</span> {{ hsProduct }}</p>
              <p><span id="subtitle">HS Code USA:</span> {{ hsProductUSA }}</p>
              <p>
                <span id="subtitle">Notas Arm.:</span> {{ warehouseProduct }}
              </p>
              <p><span id="subtitle">Notas:</span> {{ notesProduct }}</p>
              <p><span id="subtitle">Peso:</span> {{ weightProduct }} (g)</p>
            </b-col></b-row
          >
        </b-container>
        <button class="btn btn-info" @click="openProdPage()">
          Editar Produto
        </button>
      </div>
    </b-modal>
    <!-- <button @click="cttExpresso()">EXPRESSO</button> -->
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import Loading from '@/components/Loading.vue';
export default {
  props: {
    orderId: String,
    articles: Array,
    order: Array,
    allProducts: Array,
  },
  components: {
    Loading,
  },
  data: function () {
    return {
      products: '',
      ean: '',
      filterProducts: '',
      productsArray: [],
      produtsRegisted: [],
      expedition: '',
      loading: false,
      picking: [],
      eans: '',
      lastRegist: '',
      eanProduct: '',
      skuProduct: '',
      hsProduct: '',
      hsProductUSA: '',
      warehouseProduct: '',
      notesProduct: '',
      weightProduct: '',
      imgProduct: '',
      idProduct: '',
      stockProduct: '',
      arrayArticles: [],
      img: 'https://www.svgrepo.com/show/97910/image.svg',
      skuInfo: '',
      eanInfo: '',
      nameInfo: '',
      pasteAllowed: false, // Flag para controlar se a colagem está habilitada
      acceptInput: '', // Input do usuário no modal
      lastKeyTime: 0, // Tempo do último evento
      eanInputBuffer: '', // Buffer temporário para armazenar entrada rápida
      inputTimeout: null, // Temporizador para detectar final da entrada
      inputStartTime: null, // Tempo do início da entrada
    };
  },
  methods: {
    handlePaste(event) {
      if (!this.pasteAllowed) {
        event.preventDefault();
        this.$swal({
          icon: 'warning',
          title: 'Colagem Bloqueada',
          text: 'A colagem está desativada. Utilize o leitor de código de barras.',
        });
      }
    },
    handleInput(event) {
      // Captura o valor atual do campo
      const currentInput = event.target.value;

      // Validação imediata: Se o comprimento do input for >= 8, processa diretamente
      if (currentInput.length >= 7) {
        this.ean = currentInput;
        console.log('Leitor de código de barras detectado:', this.ean);
        this.processEAN(); // Processa o código de barras
        clearTimeout(this.inputTimeout); // Cancela qualquer validação futura
        this.inputStartTime = null; // Reseta o timer
        return;
      }

      // Inicia o tempo quando o usuário começa a inserir dados
      if (!this.inputStartTime) {
        this.inputStartTime = new Date().getTime();
      }

      // Permite o usuário adicionar "0" manualmente
      if (currentInput === '0' || currentInput.endsWith('0')) {
        this.ean = currentInput; // Atualiza o valor normalmente
        console.log('Zero adicionado manualmente:', this.ean);
        return;
      }

      // Limpa o temporizador anterior
      clearTimeout(this.inputTimeout);

      // Adiciona um pequeno atraso para detectar o final da entrada
      this.inputTimeout = setTimeout(() => {
        const inputEndTime = new Date().getTime();
        const totalTime = inputEndTime - this.inputStartTime;

        // Valida se a entrada foi rápida (ex: leitor de código de barras)
        if (totalTime < 500 || this.pasteAllowed) {
          console.log('Entrada válida:', this.ean);
          this.processEAN(); // Processa o valor final do código
        } else {
          console.log('Entrada manual detectada, bloqueando...');
          this.ean = ''; // Reseta o campo
          this.$swal({
            icon: 'warning',
            title: 'Entrada Manual Bloqueada',
            text: 'Utilize o leitor de código de barras.',
          });
        }

        // Reseta o tempo de início
        this.inputStartTime = null;
      }, 200); // Atraso de 200ms para aguardar a pausa
    },

    processEAN() {
      // Função para processar o valor do EAN
      console.log('Código EAN recebido:', this.ean);
      // Adicione aqui a lógica para verificar o EAN ou enviar para o servidor
    },

    // Método para atualizar o valor do EAN
    updateEAN(event) {
      this.ean = event.target.value;
    },
    openAcceptModal() {
      this.$refs.acceptModal.show();
    },
    allowPaste() {
      if (this.acceptInput.trim().toLowerCase() === 's') {
        this.pasteAllowed = true;
        this.acceptInput = '';
        this.$refs.acceptModal.hide();
        this.$swal({
          icon: 'success',
          title: 'Desbloqueado',
          text: 'Agora você pode colar ou introduzir manualmente o EAN.',
        });
      }
    },
    handleAcceptKeyPress(event) {
      if (event.key === 'Enter') {
        this.allowPaste(); // Chama a função que desbloqueia a colagem
      }
    },
    async openProdPage() {
      window.open(
        `https://${window.location.host}/product/${this.idProduct}`,
        '_blank'
      );
      this.$refs['modal_product'].hide();
    },
    /* OBTER TODOS OS DADOS DOS PRODUTOS DAS ENCOMENDAS */
    async createArrayForArticles() {
      for (let i = 0; i < this.articles.length; i++) {
        for (let j = 0; j < this.articles[i].quantity; j++) {
          this.arrayArticles.push({
            sku: this.articles[i].sku,
            id_request: this.articles[i].id_request,
          });
        }
      }
      this.addProductsToArray();
    },
    /* REGISTAR PRODUTO */
    async registeProduct() {
      if (!this.ean) return console.error('Nenhum EAN fornecido.');

      const possibles = this.articles.filter(
        (p) => p.all_ean?.includes(this.ean) || p.all_sku?.includes(this.ean)
      );

      const stillInOrder = possibles.filter((prod) =>
        this.arrayArticles.some(
          (item) =>
            item.sku === prod.sku &&
            (!item.id_request ||
              !prod.id_request ||
              String(item.id_request) === String(prod.id_request))
        )
      );

      // ------------------------- PRODUTO NÃO ESTÁ NA ENCOMENDA -------------------------
      if (!possibles.length || !stillInOrder.length) {
        try {
          await this.$store.dispatch('searchProductsEanSku', {
            search: this.ean,
          });

          const prod_found = this.getProductsSkuEan;
          if (!prod_found?.[0])
            throw new Error('Produto não encontrado na API.');
          const p = prod_found[0];

          const verificationCode = Math.floor(
            100 + Math.random() * 900
          ).toString();

          await this.$swal({
            icon: 'error',
            title:
              '<span style="color:white;font-size:2.5rem;font-weight:bold;">Produto não faz parte da encomenda</span>',
            html: `
          <div style="text-align:center;color:white;font-size:1.5rem;">
            <img src="${p.img}" style="max-width:300px;margin:20px auto;">
            <p><strong>SKU:</strong> ${p.sku[0]}</p>
            <p><strong>EAN:</strong> ${p.ean[0]}</p>
            <p><strong>Nome:</strong> ${p.name}</p>
            <p>Digite o código: <strong>${verificationCode}</strong></p>
            <input id="confirmInput" style="margin-top:20px;font-size:1.2rem;text-align:center;background:white;color:black;border:2px solid #d33;border-radius:5px;">
          </div>
        `,
            confirmButtonText:
              '<span style="color:white;font-size:1.2rem;">Confirmar</span>',
            confirmButtonColor: '#b71c1c',
            allowOutsideClick: false,
            allowEscapeKey: false,

            didOpen: () => {
              document.querySelector('.swal2-popup').style.backgroundColor =
                'red';
              document
                .getElementById('confirmInput')
                .addEventListener('keydown', (e) => {
                  if (e.key === 'Enter')
                    document.querySelector('.swal2-confirm').click();
                });
            },

            preConfirm: () => {
              const v = document.getElementById('confirmInput').value;
              if (v !== verificationCode)
                this.$swal.showValidationMessage(
                  `O código deve ser exatamente: ${verificationCode}`
                );
              return v;
            },
          });

          await this.$store.dispatch('lockOrder', {
            order_id: this.orderId,
            id: 7,
          });
          this.$router.push('/orders');

          this.img = 'https://www.svgrepo.com/show/97910/image.svg';
          this.skuInfo = this.eanInfo = this.nameInfo = '';
        } catch (err) {
          console.error('Erro ao buscar produto:', err);
        }
        return;
      }

      // ------------------------- PRODUTO ENCONTRADO -------------------------

      const findProduct = JSON.parse(JSON.stringify(stillInOrder[0]));
      const matchingIndex = this.arrayArticles.findIndex(
        (item) =>
          item.sku === findProduct.sku &&
          (!item.id_request ||
            !findProduct.id_request ||
            String(item.id_request) === String(findProduct.id_request))
      );

      if (matchingIndex === -1)
        return console.warn('Produto não encontrado em arrayArticles');

      // ------------------------- FUNÇÃO POPUP VALIDADE -------------------------

      const showValidityPopup = async (type) => {
        const code = Math.floor(100 + Math.random() * 900).toString();
        const isSix = type === 6;

        return await this.$swal({
          width: '45rem',
          icon: isSix ? 'error' : 'warning',
          title: `
        <span style="color:white;font-size:2.5rem;font-weight:bold;">
          Validade Inferior a ${isSix ? '6' : '9'} Meses!
        </span>
      `,
          html: `
        <div style="text-align:center;color:white;font-size:1.5rem;">
          <img src="${findProduct.img}" style="max-width:300px;margin:20px auto;border-radius:12px;">
          <p><strong>Produto:</strong> ${findProduct.name}</p>
          <p><strong>SKU:</strong> ${findProduct.all_sku?.[0]}</p>
          <p><strong>Validade:</strong> ${findProduct.validity}</p>
          <p style="margin-top:20px;">Digite o código: <strong>${code}</strong></p>
          <input id="validityInput" style="margin-top:20px;font-size:1.2rem;text-align:center;background:white;color:black;border:2px solid #d33;border-radius:5px;">
        </div>
      `,
          showCancelButton: true,
          confirmButtonText:
            '<span style="color:white;font-size:1.2rem;">Confirmar</span>',
          confirmButtonColor: '#b71c1c',
          cancelButtonText: 'Cancelar',
          allowOutsideClick: false,
          allowEscapeKey: false,

          didOpen: () => {
            document.querySelector('.swal2-popup').style.backgroundColor = isSix
              ? '#330000'
              : '#332800';
            document
              .getElementById('validityInput')
              .addEventListener('keydown', (e) => {
                if (e.key === 'Enter')
                  document.querySelector('.swal2-confirm').click();
              });
          },

          preConfirm: () => {
            const v = document.getElementById('validityInput').value;
            if (v !== code)
              this.$swal.showValidationMessage(`O código deve ser: ${code}`);
            return v;
          },
        });
      };

      // ------------------------- CHECK DA VALIDADE -------------------------

      if (findProduct.validity) {
        const today = new Date();
        const six = new Date(today);
        six.setMonth(six.getMonth() + 6);
        const nine = new Date(today);
        nine.setMonth(nine.getMonth() + 9);
        const validDate = new Date(findProduct.validity);

        if (validDate < six) await showValidityPopup(6);
        else if (validDate < nine) await showValidityPopup(9);
      }

      // ------------------------- NOTA FINISH -------------------------

      if (
        findProduct.note_finish &&
        findProduct.note_finish !== 'null' &&
        findProduct.note_finish.trim() !== ''
      ) {
        await this.$swal({
          title: `O produto com SKU: ${findProduct.all_sku[0]} tem a seguinte nota: ${findProduct.note_finish}`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sim, continuar!',
          cancelButtonText: 'Cancelar',
        });
      }

      // ------------------------- FINALIZA REGISTO -------------------------

      this.arrayArticles.splice(matchingIndex, 1);
      this.addProductsToArray();

      findProduct.show = true;
      this.lastRegist = findProduct.all_sku[0];

      this.img = findProduct.img;
      this.skuInfo = findProduct.all_sku[0];
      this.eanInfo = findProduct.all_ean[0];
      this.nameInfo = findProduct.name;

      console.log('Produto registado com sucesso:', this.lastRegist);
      this.ean = '';
    },

    /* ADICIONAR OS PRODUTOS A UM ARRAY */
    async addProductsToArray() {
      this.produtsRegisted = [];

      for (let i = 0; i < this.articles.length; i++) {
        const { sku, id_request, quantity } = this.articles[i];

        const remaining = this.arrayArticles.filter((item) => {
          return (
            item.sku === sku &&
            (!item.id_request ||
              !id_request ||
              String(item.id_request) === String(id_request))
          );
        });

        const index = this.produtsRegisted.findIndex((product) => {
          return (
            product.sku === sku &&
            (!product.id_request ||
              !id_request ||
              String(product.id_request) === String(id_request))
          );
        });

        if (index === -1) {
          this.produtsRegisted.push({
            sku,
            id_request,
            registed: quantity - remaining.length,
            total: quantity,
          });
        } else {
          this.produtsRegisted[index].registed = quantity - remaining.length;
        }
      }
    },
    async openGoogle() {
      window.open(
        `https://www.google.com/maps/search/?api=1&basemap=satellite&query=${this.order[0].adress1.replace(
          /\s*$/,
          ''
        )}, ${this.order[0].city}, ${this.order[0].state}, ${
          this.order[0].postcode
        }, ${this.order[0].country}`,
        '_blank'
      );
    },
    /* ESCOLHER DISTRIBUIDORA */
    async choiceCompany() {
      /* this.loading = true; */
      console.log(this.order);
      /* try {
        console.log(this.order[0].id_invoice);
        if (this.order[0].id_invoice == "") {
          await this.$store.dispatch("fetchInvoices", {
            order: this.orderId,
          });
          setTimeout(this.next, 5000);
        } else { */
      this.$parent.getOrder(true);
      this.$root.$emit('shippingCompany');
      this.$parent.choiceCompany();
      /* }
      } catch (err) {
        this.$swal({
          toast: true,
          position: "top-end",
          icon: "error",
          title: err,
          showConfirmButton: false,
          timer: 1500,
        });
      } */
    },
    async next() {
      alert('ESPEROU');
      this.$parent.getOrder(true);
      this.$root.$emit('shippingCompany');
      /* this.$parent.choiceCompany(); */
      this.loading = false;
    },
    /* VERIFICAR A DISTRIBUIDORA DO ENVIO */
    async checkOrderExpedition() {
      try {
        await this.$store.dispatch('fetchOrderExpeditionByID', {
          id: this.id,
        });
        this.expedition = this.getOrderExpeditionByID.data;
        console.log(this.expedition);
        if (this.expedition.length != 0) {
          if (this.expedition[0].shipping_company == 'nacex') {
            this.$parent.getNacexLabel(this.expedition[0].expedition_number);
          } else if (this.expedition[0].shipping_company == 'dhl') {
            console.log(this.expedition[0].tracking_number);
            console.log(this.expedition);
            this.$parent.getCallDHLLabel(
              this.expedition[0].expedition_number,
              this.expedition[0].tracking_number,
              this.expedition[0].xml
            );
          } else if (this.expedition[0].shipping_company == 'ctt expresso') {
            this.$parent.getCallCTTEXPRESSOLabel(
              this.expedition[0].expedition_number
            );
          } else if (this.expedition[0].shipping_company == 'ctt') {
            this.$parent.callCTTLabel(
              this.expedition[0].expedition_number,
              this.expedition[0].tracking_number
            );
          } else if (this.expedition[0].shipping_company == 'fedex') {
            this.$parent.getFedExLabbel(
              this.expedition[0].expedition_number,
              this.expedition[0].tracking_number
            );
          } else if (this.expedition[0].shipping_company == 'estafeta_braga') {
            // Sem etiqueta nem tracking — não é necessário fazer nada
            console.log('Estafeta Braga - sem etiqueta');
          }
        }
      } catch (err) {
        alert(err);
      }
    },
    async getEAN() {
      console.log('Entrou Atualizar EAN');
      try {
        try {
          await this.$store.dispatch('fetchProductsEAN');
          this.eans = this.getProductsEAN;
          console.log('TODOS EANS: ', this.eans);
          /* VERIFICA QUANTAS LINHAS TERÁ A TABELA */
        } catch (err) {
          alert(err);
        } finally {
          this.loading = false;
        }
      } catch (err) {
        alert(err);
      }
    },
    async passProductData(data) {
      // const filterProduct = this.allProducts.filter((product) => product.sku.includes(data.sku));
      this.eanProduct = data.ean;
      this.skuProduct = data.all_sku[0];
      this.hsProduct = data.hscode;
      this.hsProductUSA = data.hscodeusa;
      this.warehouseProduct = data.note_warehouse;
      this.notesProduct = data.note_finish;
      this.weightProduct = data.weight;
      this.imgProduct = data.img;
      this.idProduct = data.id_backoffice;
      this.stockProduct = data.stock;
      // console.log(filterProduct, data);
    },
  },

  computed: {
    ...mapGetters(['getOrderProducts']),
    ...mapGetters(['getOrderExpeditionByID']),
    ...mapGetters(['getProductsSkuEan']),
    // ...mapGetters(['getProductsEAN']),
  },
  mounted() {
    // this.$root.$on('component1', () => {
    //   // your code goes here
    //   this.getProductsFromOders();
    // });
  },
  async created() {
    // await this.getProductsFromOders();
    await this.createArrayForArticles();
    await this.checkOrderExpedition();
    // await this.allCountries();
    // await this.openValidationAddress();
    // await this.getEAN();
  },
};
</script>
<style scoped>
.card {
  padding: 25px;
  background-color: rgba(255, 147, 147, 0.733);
  margin: 50px;
  border: 1px solid #dddd;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}
h3 {
  color: white;
}
p {
  text-align: center;
}
.completed {
  color: green;
  font-weight: bold;
}
form {
  margin: 10px;
}
label {
  text-align: right;
  color: white;
  font-weight: bold;
}
hr {
  background-color: white;
  height: 2px;
  border: 0;
}
#eanLabel {
  background-color: rgb(74, 106, 192);
  border-radius: 6px;
  color: white;
}
.google {
  text-align: center;
}
.google button {
  background-color: none;
}
#modal-address label {
  background-color: white;
  color: black;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
button {
  background-color: rgb(104, 155, 75);
  border: none;
}
button:hover {
  background-color: rgba(104, 155, 75, 0.788);
  border: none;
  box-shadow: none;
}
button:focus {
  background-color: rgb(104, 155, 75);
  border: none;
  box-shadow: none;
}
i {
  text-align: center;
  color: grey;
  opacity: 0.6;
}
img {
  max-width: 100%;
  border-radius: 18px;
}
.card {
  padding: 25px;
  background-color: rgba(255, 147, 147, 0.733);
  margin: 10px;
  border: 1px solid #dddd;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}
#subtitle {
  color: white;
  font-weight: bold;
}
#openArticle {
  color: rgb(0, 98, 255);
}
#openArticle:hover {
  text-decoration: underline;
}
.box img {
  width: 100%;
  height: 200px;
}
.box1 img {
  object-fit: contain;
}
.box1 {
  border: 3px solid #ff9393;
  border-radius: 5px;
}
.infoProduct {
  margin-top: 3%;
}
.registerInput {
  margin-top: 7%;
}
.input-group {
  display: flex;
  align-items: center;
}

.unlock-icon {
  font-size: 16px;
  color: black; /* Ícone preto */
  cursor: pointer;
  transition: transform 0.2s ease, color 0.2s ease;
}

.unlock-icon:hover {
  color: #333; /* Preto mais intenso no hover */
  transform: scale(1.2); /* Aumenta o ícone no hover */
}

.last-registered {
  font-size: 14px;
  color: #6c757d; /* Cinza suave */
}

#eanLabel {
  color: #495057;
}

input.form-control {
  border: 1px solid #ced4da;
  box-shadow: none;
  font-size: 14px;
}

input.form-control:focus {
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.btn-primary {
  background-color: #007bff;
  border: none;
}

.btn-primary:hover {
  background-color: #0056b3;
}
</style>
